/*
  The popup behind "Choose size" / "Choose colour" on product cards.

  It used to fetch the whole product page and drop it in here, which gave the
  shopper a cut-down product page inside a box. Now it fetches a panel built for
  the job - sections/magnum-quick-add.liquid - through Shopify's section
  rendering API, and magnum-quick-add.js runs the choosing inside it.
*/
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        const productUrl = opener.getAttribute('data-product-url');

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('section_id', 'magnum-quick-add');

        fetch(url.toString())
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const panel = responseHTML.querySelector('magnum-quick-add');

            // Nothing to show - send the shopper to the product page rather
            // than opening an empty box at them.
            if (!panel) {
              window.location = productUrl;
              return;
            }

            this.modalContent.closest('.quick-add-modal__content').classList.add('quick-add-modal__content--compact');
            HTMLUpdateUtility.setInnerHTML(this.modalContent, panel.outerHTML);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}
